import itemlist from './itemlist';

export default itemlist;



// WEBPACK FOOTER //
// ./src/components/itemlist/index.js